import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { Text } from '~/shared/ui/Text'

import { SEGMENT_HEIGHT } from './config'
import type { SegmentProps } from './types'

import styles from './Segment.module.scss'

const SegmentItem = memo(function SegmentItem(props: {
  option: { key: string; text: string }
  isActive: boolean
  height: string
  onSelect: (key: string) => void
}) {
  const { option, isActive, height, onSelect } = props
  const { pressProps, isPressed } = usePress({ onPress: () => onSelect(option.key) })

  return (
    <button
      className={cn(styles.item, isActive && styles.isActive)}
      type='button'
      data-pressed={isPressed}
      aria-pressed={isActive}
      style={{ height }}
      {...pressProps}
    >
      <Text variant='BODY_S' color='INHERIT'>
        {option.text}
      </Text>
    </button>
  )
})

/** Сегмент-контрол «Месяц/Год» и т.п., спека 01 §29. */
export const Segment = memo(function Segment(props: SegmentProps) {
  const { options, value, onChange, size = 'M' } = props
  const height = SEGMENT_HEIGHT[size]

  return (
    <div className={styles.root}>
      {options.map((option) => (
        <SegmentItem
          key={option.key}
          option={option}
          isActive={option.key === value}
          height={height}
          onSelect={onChange}
        />
      ))}
    </div>
  )
})
